;(function(){
	if (!$("body").hasClass("post-type-archive-adac_jobs")) return;

	console.log("employment.js");
	
	$(".readMore").on("click", function() {
		$(".readMoreContent").slideUp();
		$(".readMore").slideDown();
		$(this).slideUp();
		$(this).parent().find(".readMoreContent").slideDown();
	})
})();